import React, { useState } from "react";
import { NavLink } from "react-router-dom";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import logo from '../images/familee_tree_logo.svg';
import minilogo from '../images/minilogo.svg';
import { faUser, faHouse, faClipboard, faAddressBook, faCaretDown, faCaretUp } from '@fortawesome/free-solid-svg-icons';
import Header from "./Header";

const Sidebar = ({ children }) => {
    const [isMasterDataOpen, setMasterDataOpen] = useState(false);
    const [isOpen, setIsOpen] = React.useState(false);

    const menuList = [
        { path: "/dashboard", name: "Dashboard", tag: "Dashboard", role: "superAdmin", icon: <FontAwesomeIcon icon={faHouse} /> },
        { path: "/user", name: "User", tag: "User", role: "superAdmin", icon: <FontAwesomeIcon icon={faUser} /> },
        { path: "/mediaPost", name: "Media Post", tag: "MediaPost", role: "superAdmin", icon: <FontAwesomeIcon icon={faClipboard} /> },
        { path: "/report", name: "Reported Post", tag: "ReportedPost", role: "superAdmin", icon: <FontAwesomeIcon icon={faAddressBook} /> },
        {
            // path: "/masterData",
            name: "Master Data",
            tag: "MasterData",
            role: "superAdmin",
            icon: <FontAwesomeIcon icon={faClipboard} />,
            children: [
                { path: "maritalStatus", name: "Marital Status", role: "superAdmin" },
                { path: "Religion", name: "Religion", role: "superAdmin" },
                { path: "castes", name: "Castes", role: "superAdmin" },
                { path: "hobbiesAndInterets", name: "Hobbies and Interests", role: "superAdmin" },
                { path: "languages", name: "Languages", role: "admin" },
                { path: "qualifications", name: "Qualifications", role: "superAdmin" },
                { path: "fieldsOfStudy", name: "Fields Of Study", role: "superAdmin" },
                { path: "abuseWord", name: "Abuse Words", role: "superAdmin" },
            ],
        },

        // { path: "/setting", name: "Setting", role: "admin", icon: <FontAwesomeIcon icon={faGear} /> },
        // { path: "/setting", name: "Setting", role: "admin", icon: <FontAwesomeIcon icon={faGear} /> },
    ];

    const toggleSidebar = () => {
        setIsOpen(!isOpen);
        setMasterDataOpen(false);
      };

    const toggleMasterData = () => {
        setMasterDataOpen(!isMasterDataOpen);
        setIsOpen(false);
    };

    return (
        <React.Fragment>
            <div className="containers">
                <div className={`sidebar ${isOpen ? 'open' : 'closed'}`}>
                    <div className="top-section">
                        <div className="logo">
                            <img src={isOpen ? minilogo : logo } alt="FamileeTree" />
                        </div>
                    </div>
                    {menuList.filter(val => val.role === "superAdmin").map((item, i) => (
                        <div key={i}>
                            <NavLink to={item.path} className="sidebarLink"   >
                                <div className="link-icon" >{item.icon}</div>
                                <div className={`link-text ${isOpen ? 'open' : 'closed'}`} >{item.name}</div>
                                <div className="link-text" onClick={toggleMasterData} >{item.tag === "MasterData" ?  <span >
                                        {isMasterDataOpen ? <FontAwesomeIcon icon={faCaretUp} /> : <FontAwesomeIcon icon={faCaretDown} />}
                                    </span> : null}</div>
                            </NavLink>
                            {item.children && item.name === "Master Data" && (
                                <div >
                                   
                                    {isMasterDataOpen && (
                                        <ul className="submenu">
                                            {item.children.map((child) => (
                                                <li key={child.path}>
                                                    <NavLink to={`${child.path}`} className="master-sidebarLink">
                                                        {child.name}
                                                    </NavLink>
                                                </li>
                                            ))}
                                        </ul>
                                    )}
                                </div>
                            )}
                        </div>
                    ))}
                </div>
                <div className= {`aside ${isOpen ? 'open' : 'closed'}`} >
                    <Header toggleSidebar={toggleSidebar} />
                    <main>{children}</main>
                </div>
            </div>
        </React.Fragment>
    );
};

export default Sidebar;
